import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { Avatar, Box, Fab, Tooltip, Typography } from '@mui/material';
import { Download, Facebook, LinkedIn, Mail, Phone, QrCodeScanner } from '@mui/icons-material';
import { t } from 'i18next';
import Data from "../Data/.json"
import GetCookie from '../Services/GetCookie';
import env from 'react-dotenv';
import image from "../Files/contact.svg"
import ConatctQr from "../Files/ContactQr.png"

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ContactQr() {
  const [open, setOpen] = React.useState(false);

  const cookieMode = GetCookie(Data.mode);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Tooltip title="Mon contact">
        <Fab onClick={handleClickOpen} style={{ position: 'fixed', bottom: 50, right: 20, backgroundColor: "#164F7D" }}>
          <QrCodeScanner style={{ color: "white" }} />
        </Fab>
      </Tooltip>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent className='boxQrContact' style={{ backgroundColor: (cookieMode == "dark") ? "#032025" : (cookieMode == "light") ? "white" : "inherit", color: (cookieMode == "dark") ? "white" : (cookieMode == "light") ? "black" : "inherit" }}>

          <center>
            <img width={200} src={image} alt="" />
            <Box sx={{ flexGrow: 1, display: { xs: 'block', md: 'flex' } }}>
              <Box alignContent={"center"} >
                <Box gap={1} display={"flex"}>
                  <Avatar style={{width: "25px", height: "25px",}} ><Phone style={{width: "15px"}}/></Avatar>
                  <label>(+237 690 767 963)</label>
                </Box><br />
                <Box gap={1} display={"flex"}>
                  <Avatar style={{width: "25px", height: "25px", backgroundColor: "lightpink"}} ><Mail style={{width: "15px"}}/></Avatar>
                  <label >contact@ibgalphatech.com</label>
                </Box>
                <br />
                <Box gap={1} display={"flex"}>
                  <Avatar style={{width: "25px", height: "25px", backgroundColor: "darkblue"}} ><Facebook style={{width: "15px"}}/></Avatar>
                  <label >@ibgalphatech</label>
                </Box>
                <br />
                <Box gap={1} display={"flex"}>
                  <Avatar style={{width: "25px", height: "25px", backgroundColor: "lightblue"}} ><LinkedIn style={{width: "15px"}}/></Avatar>
                  <label >@ibgalphatech</label>
                </Box>
              </Box>
              <Box>
                <DialogTitle>{t("contact")}</DialogTitle>
                <img style={{ borderRadius: "10px" }} width={"50%"} src={ConatctQr} alt="" />
                <DialogTitle style={{ fontSize: "smaller", fontWeight: "lighter" }}>{t("contact-sous-titre")}</DialogTitle>
                {/* <br />
            <Button onClick={() => { window.open(env.DOWNLOAD_CONTACT_LINK) }} startIcon={<Download />} >{t("telecharger")}</Button> */}
              </Box>
            </Box>
          </center>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}